import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import ApiService from '../services/ApiService';

const OPEN_STATUSES = ['pending', 'confirmed', 'in progress'];

/**
 * Asks for confirmation, then deletes `booking` (a soft delete — see
 * admin bookingController.destroy). Shared by the bookings list row and the
 * Booking Details panel. Resolves true once deleted.
 *
 * Deleting is not cancelling: nothing is refunded and the customer is not
 * notified, so an open paid booking gets an extra warning pointing at Cancel.
 */
export async function confirmDeleteBooking(booking) {
    if (!booking?._id) return false;

    const code = booking.booking_code || `#${String(booking._id).slice(-6)}`;
    const isOpen = OPEN_STATUSES.includes(String(booking.status || '').toLowerCase());
    const isPaid = String(booking.payment_status || '').toLowerCase() === 'paid' && Number(booking.grand_total) > 0;

    const result = await Swal.fire({
        title: `Delete booking ${code}?`,
        html: isOpen
            ? `This booking is still <b>${booking.status}</b>. Deleting removes it and frees the time slot, but the customer is <b>not notified</b>`
              + (isPaid ? ' and <b>no refund is issued</b>' : '')
              + '.<br/><br/>To let the customer know, use <b>Cancel Booking</b> instead.'
            : 'It will be removed from bookings, the calendar and reports. This cannot be undone.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it',
        cancelButtonColor: '#9E9B9B',
        cancelButtonText: 'No',
        focusCancel: true,
    });
    if (!result.isConfirmed) return false;

    try {
        const res = await ApiService.request({ method: 'DELETE', url: `admin/bookings/${booking._id}` });
        if (res.data.status) {
            toast.success(res.data.message || 'Booking deleted');
            return true;
        }
        toast.error(res.data.message || 'Failed to delete booking');
    } catch {
        toast.error('Failed to delete booking');
    }
    return false;
}
